import styled from "styled-components";
export const Container = styled.div`
  margin: 0 auto;
  background-color: #e5f5f2;
  border-radius: 20px;

  .main-div {
    background-color: white;
    border-radius: 20px;
    height: calc(-100px + 100vh);
    @media screen and (max-width: 768px) {
      height: auto;
    }
    @media (max-width: 380px) and (max-height: 800px) {
      height: calc(100vh);
      /* padding-bottom: 20px; */
    }
  }
`;
export const ContentSection = styled.div`
  padding: 20px 16px;

  @media (min-width: 768px) {
    padding: 24px 20px;
  }
`;
export const Title = styled.h3`
  color: #142c1f;
  margin: 0 0 12px;
  font-size: 16px;
  @media screen and (min-width: 768px) {
    text-align: center;
  }
`;
export const RezeptTitle = styled.h3`
  color: #142c1f;
  margin: 0 0 16px;
  font-size: 16px;
  @media screen and (min-width: 768px) {
    text-align: center;
  }
`;
export const Description = styled.p`
  color: #818d88;
  margin: 0 0 24px;
  @media screen and (min-width: 768px) {
    text-align: center;
  }
`;
